import Header from '../../components/Layout/Header';
import TrackDatManual from '../../components/TrackDatManual/TrackDatManual';
import { getTrackDatManualProps } from '../../lib/trackdatManual';
import styles from '../TrackDatTesting.module.css';

export function getStaticProps() {
  return { props: getTrackDatManualProps() };
}

function TrackDatTestingManualPage(props) {
  return <TrackDatManual {...props} productRoute="/TrackDatTesting" />;
}

TrackDatTestingManualPage.getLayout = function getLayout(page) {
  return (
    <>
      <Header variant="trackdat" productHref="/TrackDatTesting" />
      <div className={styles.trackDatChromeOffset}>{page}</div>
    </>
  );
};

export default TrackDatTestingManualPage;

